var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo, useState } from "react";
import { debounce } from "lodash";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchAddressDetail, fetchAddressSuggestions, } from "../api/addressService";
export var useAddress = function (addressKey, setValue) {
    var _a = useState(""), addressQuery = _a[0], setAddressQuery = _a[1];
    var _b = useState(""), addressCode = _b[0], setAddressCode = _b[1];
    var _c = useState(false), enableAddress = _c[0], setEnableAddress = _c[1];
    var ky = useOkapiKy();
    var debouncedSetAddressQuery = useCallback(debounce(function (inputValue) {
        setAddressQuery(inputValue);
    }, 300), []);
    var handleAddressQuery = function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, debouncedSetAddressQuery(inputValue)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleToggleAddress = function () {
        var newValue = !enableAddress;
        setEnableAddress(newValue);
        if (!newValue) {
            setValue("".concat(addressKey, ".street"), "");
            setValue("".concat(addressKey, ".postalCode"), "");
            setValue("".concat(addressKey, ".municipality"), "");
            setValue("".concat(addressKey, ".regionId"), "");
        }
    };
    var addressSuggestions = useQuery(["addressSuggestion", addressQuery], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (addressQuery.length < 3)
                return [2 /*return*/, []];
            return [2 /*return*/, fetchAddressSuggestions(ky, addressQuery)];
        });
    }); }, {
        retry: false,
    }).data;
    useQuery(["addressDetail", addressCode], function () {
        if (addressCode !== "")
            return fetchAddressDetail(ky, addressCode);
        return null;
    }, {
        onSuccess: function (addressDetail) {
            var _a;
            if (addressDetail) {
                setValue("".concat(addressKey, ".street"), addressDetail.street);
                setValue("".concat(addressKey, ".postalCode"), addressDetail.postalCode);
                setValue("".concat(addressKey, ".municipality"), addressDetail.municipality);
                setValue("".concat(addressKey, ".regionId"), ((_a = addressDetail.region) === null || _a === void 0 ? void 0 : _a.id) || addressDetail.regionId || "");
                setEnableAddress(false);
            }
        },
    });
    var addressDataOptions = useMemo(function () {
        var _a;
        return (_a = addressSuggestions === null || addressSuggestions === void 0 ? void 0 : addressSuggestions.map(function (suggestion) { return ({
            value: suggestion.addressCode,
            label: suggestion.address,
        }); })) !== null && _a !== void 0 ? _a : [];
    }, [addressSuggestions]);
    return {
        addressQuery: addressQuery,
        setAddressQuery: setAddressQuery,
        handleAddressQuery: handleAddressQuery,
        setAddressCode: setAddressCode,
        addressDataOptions: addressDataOptions,
        handleToggleAddress: handleToggleAddress,
        enableAddress: enableAddress,
        setEnableAddress: setEnableAddress,
    };
};
